import { FC } from 'react';
import cn from 'classnames';
import { ButtonProps } from './BuyButton.props';
import CartIcon from '@/public/images/cart.svg';
import { useLocaleHook } from '@/hooks';

import s from './BuyButton.module.css';

export const BuyButton: FC<ButtonProps> = ({
  className,
  disabled = false,

  ...props
}) => {
  const locale = useLocaleHook();

  return (
    <button
      className={cn(s.btn, className)}
      disabled={disabled}
      aria-label={locale == 'uk' ? 'Де купити' : 'Where to buy'}
      {...props}
    >
      <CartIcon className="h-[23px] w-6" />
    </button>
  );
};
